import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { getBlogs } from "./blogsApi"

const initialState = {
    isLoading: false,
    isError: false,
    blogs: [],
    error: ""
}

export const fetchBlogs = createAsyncThunk("blogs/fetchBlogs", async(filter) => {
    const blogs = getBlogs(filter);
    return blogs;
})



const blogsSlice = createSlice({
    name: "blogs",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchBlogs.pending, (state, action) => {
            state.isLoading = true;
            state.isError = false;
            state.error = ""
        })
        builder.addCase(fetchBlogs.fulfilled, (state, action) => {
            state.isLoading = false;
            state.blogs = action.payload
        })
        builder.addCase(fetchBlogs.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.blogs = []
            state.error = action.error.message
        })
    }
})

export default blogsSlice.reducer;